import { AuthApi, konjInstance } from "api";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { CookieUtils } from "utils";

function useKonjUserInfo(data, isEnable = true) {
  return useQuery("konjUserInfo", () => AuthApi.getKonjUserInfo(data), {
    refetchOnWindowFocus: false,
    retry: false,
    enabled: isEnable,
    onSuccess: (data) => {
      CookieUtils.setCookie("konjToken", data?.token);
      konjInstance.defaults.headers.common[
        "Authorization"
      ] = `Token ${data?.token}`;
    },
  });
}
function useStudentInfo(data) {
  return useQuery(
    ["studentInfo", data.studentId],
    () => AuthApi.getStudentInfo(data),
    {
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
}

function useSyncKonjUser() {
  const queryClient = useQueryClient();
  return useMutation((data) => AuthApi.syncKonjUser(data), {
    onSuccess: (data) => {
      queryClient.refetchQueries("konjUserInfo");
    },
    retry: false,
  });
}

function useGenerateKonjToken({ onError }) {
  const queryClient = useQueryClient();
  return useMutation((data) => AuthApi.generateExternalKonjToken(data), {
    onSuccess: (data) => {
      localStorage.clear();
      CookieUtils.removeCookie("konjToken");
      queryClient.refetchQueries("konjUserInfo");
    },
    onError: (data) => {
      onError(data?.message);
    },
    retry: false,
  });
}

function useImportKonjUser(successFunction, memberType, currentClassID) {
  const queryClient = useQueryClient();
  return useMutation(
    ({ body, tokenKonj }) =>
      AuthApi.importKonjUser({ body, tokenKonj, currentClassID }),
    {
      onSuccess: (data, variables) => {
        successFunction(data);
        queryClient.refetchQueries([
          memberType === "students" ? "ATT" : "MOD",
          "konjMembersList",
          variables.currentClassID,
        ]);
      },
      retry: false,
    }
  );
}

export {
  useKonjUserInfo,
  useSyncKonjUser,
  useImportKonjUser,
  useGenerateKonjToken,
  useStudentInfo,
};
